import { exchangeAgentGuidanceIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";

export const renameExchangeAgentGuidance = {
  name: "renameExchangeAgentGuidance" as const,
  input: z.object({
    id: exchangeAgentGuidanceIdFormat.schema,
    name: z.string().min(1),
  }),
  output: z.object({}),
};
